import { FC } from 'react';
// components
import EditExcipientComponent from 'components/main/Excipient/Edit';

const EditExcipient: FC = () => <EditExcipientComponent />;

export default EditExcipient;
